import z from "zod";
import { GrantsSchema } from "./grantsTypes";
import { AssetIdSchema, ChunkIdSchema, ConceptIdSchema, LabelIdSchema, ProjectIdSchema, SeedIdSchema } from "./idTypes";

const ChunkSchema = z.object({
  id: ChunkIdSchema,
  text: z.string(),
  assetId: AssetIdSchema,
  modifiedAt: z.string(),
  distanceFromSeed: z.number(),
});
const SeedSchema = z.object({
  id: SeedIdSchema,
  assetId: z.string(),
  name: z.string(),
  description: z.string(),
  summary: z.string(),
  chunks: z.array(ChunkSchema).optional(),
  distanceFromConcept: z.number(),
  distances: z.record(z.string(), z.number()).optional(),
  createdAt: z.string(),
  createdBy: z.string(),
});

export const ConceptSchema = z.object({
  id: ConceptIdSchema,
  name: z.string(),
  description: z.string(),
  labels: z.array(LabelIdSchema).optional(),
  summary: z.string(),
  distances: z.record(ConceptIdSchema, z.number()).optional(),
  seeds: z.array(SeedSchema).optional(),
  score: z.number(),
  /** Source of the concept: "user" = created via Define custom concept, "system" = LLM-derived. Omitted for older sync data. */
  origin: z.enum(["user", "system"]).optional(),
  createdAt: z.string(),
  modifiedAt: z.string(),
  projectId: ProjectIdSchema.optional(),
  grants: GrantsSchema.optional(),
});
export type Concept = z.infer<typeof ConceptSchema>;
